<template>
  <div>

    <v-tabs v-model="tab" @change="resumeSubscription(tab)" class="pl-4">
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="(s, index) in sArr" :key="index" :href="'#'+s.name" class="primary--text text-capitalize">
            <span :style="`color:${IDS.TripOrderStatusColor[s.status?s.status[0]:'DEFAULT']}`">
                {{ s.label }} ({{ $data[s.name + 'Count'] }})
            </span>
      </v-tab>
    </v-tabs>

    <v-card height="40" class="elevation-0 px-6 my-6">
      <v-row>
        <date-range-picker :ranges="dateOptions" class="ml-1 text-body-1" :autoApply="true" opens="right" ref="picker" v-model="date">
          <div class="d-flex " slot="input" slot-scope="picker" style="height: 28px; align-items: center">
            <v-icon class="material-icons mr-2" style="font-size: 20px">mdi-calendar-range-outline</v-icon>
            <template v-if="moment(picker.startDate).format('YYYY-MM-DD')!==moment(picker.endDate).format('YYYY-MM-DD')">
              {{ dateFormatter(picker.startDate) }} - {{ dateFormatter(picker.endDate) }}
            </template>
            <template v-else>{{ dateFormatter(picker.startDate) }}</template>
          </div>
        </date-range-picker>
        <v-spacer/>
       <!-- <v-col class="mr-2 pa-0" cols="auto">Dropdown</v-col> -->
        <v-col class="pa-0" cols="4">
          <v-text-field dense clearable label="Search by Order ID, Shop name, Customer name" outlined @input="onSearch"/>
        </v-col>
       <v-col class="pa-0 ml-2" cols="auto">
          <v-btn depressed @click="startCreateOrder" class="primary">ADD ORDER</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-tabs-items v-model="tab" class="px-4">
      <v-tab-item v-for="(s, index) in sArr" :key="index" :value="s.name">
        <v-data-table :headers="headers[s.name]" :loading="$apollo.queries[s.name].loading"
                      :footerProps="footerProps" class="elevation-0 order-table" fixed-header height="calc(100vh - 270px)"
                      :items="$data[s.name]" :server-items-length="$data[s.name+'Count']" @click:row="openOrderDetail"
                      :sort-by.sync="$data[s.name+'Options'].sortBy" :sort-desc.sync="$data[s.name+'Options'].sortDesc"
                      :options.sync="$data[s.name+'Options']" @update:options="onUpdateOptions">
          <template v-slot:no-data>No Sales Orders Available</template>
          <template v-slot:no-results>No Sales Orders Available</template>
          <template v-slot:item.statusId="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
            <v-btn icon v-on="on" :style="`color:${IDS.TripOrderStatusColor[item.status]}`" @click.stop="openStatusMenu($event, item)">
              <v-icon>mdi-checkbox-blank</v-icon>
            </v-btn>
              </template> <span>{{item.TripOrderStatus.name}}</span>
            </v-tooltip>
          </template>
         <!-- <template v-slot:item.print="{item}">
            <v-btn icon title="Print Order" :loading="item.loading" @click.stop="onPrintOrder(item)"
                   v-if="![IDS.orderStatus.Canceled, IDS.orderStatus.Rejected].includes(item.status)">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template> -->
          <template v-slot:item.created_at="{ item }">{{ moment(item.created_at).format('DD MMM YYYY hh:mm A') }}</template>
          <template v-slot:item.orderNum="{ item }">#{{item.orderNum}}</template>
          <template v-slot:item.shopName="{ item }">{{item.Organization.name}}</template>
          <template v-slot:item.customerName="{ item }">{{ (item.Organization.Users.length&&item.Organization.Users[0].name)||'-' }}</template>
          <template v-slot:item.route="{ item }">{{item.ToRouteShops.length?item.ToRouteShops[0].Route.name:'-'}}</template>
          <template v-slot:item.roundOfValue="{ item }">{{ currencyFormatter(item.finalPrice) }}</template>
          <template v-slot:item.orderItemCount="{ item }">{{ item.OrderItems_aggregate.aggregate.count }}</template>
          <template v-slot:item.updated_at="{ item }">{{(moment(item.updated_at).format('DD MMM YYYY hh:mm A'))}}</template>
          <template v-slot:item.actions="{}">
            <v-menu nudge-bottom="25">
              <template v-slot:activator="{ on:menu }">
                <v-btn icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
              </template>
              <v-list dense>
                <v-list-item dense><v-list-item-title>Edit Order</v-list-item-title></v-list-item>
                <v-list-item dense><v-list-item-title>Change Status</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <CreateSalesOrder :dialog.sync="orderFormDialog" @showToaster="showToaster"/>
    <SalesOrderDetail :dialog.sync="orderDetailDialog" :orderId="orderId"/>
    <Snackbar :toaster="toaster"/>
  </div>
</template>

<script>
import {IDS} from '../../Constants/IDS'
import {dateOptions} from "../../Constants/Constants";
import {generate_FETCH_SALES_ORDERS, generate_SUBSCRIBE_SALES_ORDERS_COUNT} from "../../graphql/subscriptions/SalesOrders";
import moment from "moment";
import {debounce} from 'lodash';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Snackbar from "../../components/Common/Snackbar";
import SalesOrderDetail from "./SalesOrderDetail";
import CreateSalesOrder from "./CreateSalesOrder";
// import Vue from 'vue';
let sArr = [
  {name: 'allOrders', status: null, label: 'All Orders'},
  {name: 'pendingOrders', status: [IDS.TripOrderStatus.OrderPlaced], label: 'Pending Orders'},
  {name: 'dispatchedOrders', status: [IDS.TripOrderStatus.Dispatched], label: 'Dispatched Orders'},
  {name: 'deliveredOrders', status: [IDS.TripOrderStatus.Delivered], label: 'Delivered Orders'}
];
let qObj = {}, sObj = {}, options = {page: 1, itemsPerPage: 25, offset: 0, limit: 25, sortBy: ['updated_at'], sortDesc: [true]};
function commonVariables(s)  {
  return {
    status: s.status,
    search: this.search,
    distributorId: JSON.parse(localStorage.user).organization.id,
    startDate: moment(this.date.startDate, 'YYYY-MM-DD').startOf('day'),
    endDate: moment(this.date.endDate, 'YYYY-MM-DD').endOf('day'),
  }
}
function pageVariables(s) {
  return {
    orderBy: this.prepareSortObject(this[s.name + 'Options'].sortBy, this[s.name + 'Options'].sortDesc),
    offset: this[s.name + 'Options'].offset, limit: this[s.name + 'Options'].limit
  }
}

sArr.forEach(s => {
  qObj[s.name] = {                                                          /* Smart Query */
    query() {return generate_FETCH_SALES_ORDERS(s.name)},
    skip() {return s.name !== 'allOrders'},
    fetchPolicy: 'network-only',
    variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
    subscribeToMore: {
      document() {return generate_FETCH_SALES_ORDERS(s.name, 'subscription')},
      variables() {return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
      updateQuery: function(previousQueryResult, {subscriptionData: {data}}) {  this[s.name] = data[s.name] }
    },
    result({data}) { this[s.name] = data[s.name] },
  };
  sObj[s.name + 'Count'] = {
    query() { return generate_SUBSCRIBE_SALES_ORDERS_COUNT(s.name + 'Count') },
    variables() { return {...commonVariables.call(this, s)}},
    result({data}) { this[s.name + 'Count'] = data[s.name + 'Count'].aggregate.count },
  };
});
export default {
  name: "SalesOrders",
  components: {SalesOrderDetail, CreateSalesOrder, Snackbar, DateRangePicker},
  apollo:{
    $subscribe: {...sObj},
    ...qObj,
   /* Distributors: {
      query: GET_ORGANIZATIONS_BY_TYPE, fetchPolicy: 'network-only',
      variables () {return { orgType: [IDS.organizationTypes.Distributor] }}
    }, */
  },
  data(){
    return{
      IDS, dateOptions, moment,
      tab: 'allOrders',
      sArr: sArr,
      search: '%%',
      ...sArr.reduce((ac, s) => {ac[s.name] = []; ac[s.name + 'Count'] = 0; ac[s.name + 'Options'] = {...options}; return ac}, {}),    // newOrders: []
      columns: [
        {text: 'Status', value: 'statusId', width: 10, sortable:false}, /*{text: '', value: 'print', width: 10, sortable:false }, */
        { text: 'Order ID', value: 'orderNum', width:80 }, { text: 'Shop Name', value: 'shopName', width:200},
        { text: 'Customer Name', value: 'customerName', width:200, sortable:false},
        { text: 'Route', value: 'route', width:150, sortable:false},
        { text: 'Amount', value: 'roundOfValue' }, { text: 'Ordered Item', value: 'orderItemCount', width:10 },
        { text: 'Created On', value: 'created_at', width:180 }, { text: 'Updated On', value: 'updated_at', width:180 }
      ],
      footerProps: {'items-per-page-options': [25, 100, 150, 200, -1]},
      date: { startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') },
      permissions: {},
      statusMenu: false,
      menuPositionX: 0,
      menuPositionY: 0,
      headers: {},
      orderDetailDialog: false,
      orderId: null,
      statusId: null,
      toaster: {},
      orderFormDialog: false
    }
  },
  methods:{
    prepareSortObject([sortBy], [order]) {
      order = order ? 'desc' : 'asc';
      if(['created_at', 'roundOfValue', 'orderNum', 'orderItemCount', 'updated_at'].includes(sortBy)) return {[sortBy]: order};
      if(sortBy === 'shopName') return {Organization: {name: order}};
      return null
    },
    async resumeSubscription(tab) {
      setTimeout(() => this.$apollo.queries[tab].skip = false, 500)
    },
    onUpdateOptions(val) {
      if (val.itemsPerPage === -1) {                                         //'ALL' Rows per page
        this[this.tab + 'Options'].limit = this[this.tab + 'Count'];          //assign total count
        this[this.tab + 'Options'].offset = 0
      } else {
        this[this.tab + 'Options'].limit = val.itemsPerPage;
        this[this.tab + 'Options'].offset = (val.page - 1) * val.itemsPerPage;
      }
    },
    startCreateOrder () {
      this.orderFormDialog = true
    },
    openStatusMenu(e, row){
      /* Disable for Delivered/Canceled/Rejected stage */
      if([IDS.orderStatus.Delivered, IDS.orderStatus.Canceled, IDS.orderStatus.Rejected].includes(row.status)) return;
      this.orderId = row.id;
      this.statusId = row.status;
      this.menuPositionX = e.clientX - e.offsetX - (e.target.clientWidth === 24?6:0);
      this.menuPositionY = e.clientY + e.target.clientHeight - e.offsetY + (e.target.clientHeight === 24?6:0);
      this.statusMenu = true;
    },
    openOrderDetail(row) {
      this.orderId = row.id;
      this.orderDetailDialog = true;
    },
    onSearch: debounce(async function (val) {
      this.search = val ? ('%' + val + '%') : '%%';
      sArr.forEach(s => this[s.name + 'Options'] = {...options})          //on search, reset page options
    }, 500),
    getHeaders(){
      sArr.forEach(s => {
        if(['allOrders', 'pendingOrders', 'dispatchedOrders'].includes(s.name)) this.headers[s.name] = [
          ...this.columns, /*{text: 'Actions', value: 'actions', sortable: false}*/];
        else this.headers[s.name] = this.columns
      });
    },
    showToaster (data) { this.toaster = data },
  },
  beforeMount () {
    // this.permissions = this.$store.getters.permissionByScreen('Distributors');
    this.getHeaders();
  },
}
</script>

<style scoped>
/deep/ tr:hover {
  cursor: pointer !important;
}
</style>